import { __assign } from "tslib";
var cacheMap = new WeakMap();
export function convertFileToObject(file, options) {
    if (!cacheMap.get(file)) {
        cacheMap.set(file, URL.createObjectURL(file));
    }
    return __assign(__assign({}, options), { key: options.key, lastModified: file.lastModified, name: file.name, size: file.size, type: file.type, originFile: file, objectUrl: cacheMap.get(file) });
}
